import { render, staticRenderFns } from "./ExpiringDocumentsTable.vue?vue&type=template&id=d16bd028&scoped=true&"
import script from "./ExpiringDocumentsTable.vue?vue&type=script&lang=ts&"
export * from "./ExpiringDocumentsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16bd028",
  null
  
)

export default component.exports